// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3d6f93dc","703":"393306fe"}[chunkId] + ".chunk.js";
};